import { createContext } from 'react';
import { MenuContextData } from './interfaces/menu-context-props.interface';

const MenuContext = createContext<MenuContextData>({} as MenuContextData);

export default MenuContext;
